<template>
  <div>
    <router-view></router-view>

    <el-dialog
      :title="$t('message.xgmm')"
      :visible.sync="dialogShow"
      class="wy-dialog"
      :close-on-click-modal="false"
      width="600px"
      :before-close="handleClose"
    >
      <passForm v-if="dialogShow"></passForm>
    </el-dialog>

    <el-dialog
      :title="$t('message.ts')"
      :visible.sync="alertShow"
      class="wy-dialog"
      :close-on-click-modal="false"
      width="500px"
      top="24vh"
      :before-close="handleCloseAlert"
    >
      <alertDialog :msg="alertText" v-if="alertShow"></alertDialog>
    </el-dialog>

    <el-dialog
      :title="$t('message.databaseManagement')"
      :visible.sync="databaseDialogShow"
      class="wy-dialog"
      top="8vh"
      :close-on-click-modal="false"
      width="1400px"
      :before-close="handleCloseDatabase"
    >
      <databaseManage :databasePropsId="databaseId" :isApp="true" v-if="databaseDialogShow"></databaseManage>
      <!-- <passForm v-if="dialogShow"></passForm> -->
    </el-dialog>


    <el-dialog
      title=""
      :visible.sync="databaseLoginShow"
      class="wy-dialog login-dialog"
      top="12vh"
      :close-on-click-modal="false"
      width="510px"
      :before-close="handleCloseLogin"
    >
      <databaseLogin v-if="databaseLoginShow"></databaseLogin>
    </el-dialog>

    <el-dialog
      :title="$t('message.qrsctc')"
      :visible.sync="deleteDialogShow"
      class="wy-dialog wy-sjk"
			:close-on-click-modal="false"
			width="500px"
      top="22vh"
      :before-close="handleCloseDelete">
			<div class="confirm-text">{{ $t('message.qrscjs') }}</div>
			<div class="confirm-border">
				<div class="confirm-cancel" @click="handleCloseDelete">{{ $t('message.cancel') }}</div>
				<div class="confirm-sure" @click="sureDel">{{ $t('message.qd') }}</div>
			</div>
    </el-dialog>
  </div>
</template>

<script>
import passForm from "@/components/passForm.vue";
import alertDialog from "@/components/alertDialog.vue";
import databaseManage from "@/components/databaseManage.vue";
import databaseLogin from '@/components/databaseLogin.vue';
import { EventBus } from '@/utils/eventBus.js';

export default {
  name: 'App',
  components: {
    passForm,
    alertDialog,
    databaseManage,
    databaseLogin
  },
  beforeDestroy () {
    window.removeEventListener('contextmenu', this.handleContextMenu);
  },
  mounted () {
    this.$nextTick(() => {
      window.addEventListener('contextmenu', this.handleContextMenu);
    });
  },
  methods: {
    handleContextMenu (e) {
      e.preventDefault();
      return false;
    },
    sureDel () {
      EventBus.$emit('sureDel', 'test');
      this.$store.commit('CHANGE_DELETE_DIALOG_SHOW', false);
    },
    handleCloseDelete () {
      this.$store.commit('CHANGE_DELETE_DIALOG_SHOW', false);
    },
    handleCloseLogin () {
      this.$store.commit('CHANGE_DATABASE_LOGIN_SHOW', false);
    },
    handleCloseDatabase () {
      this.$store.commit('CHANGE_DATABASE_SHOW', false);
    },
    handleCloseAlert() {
      this.$store.commit("CHANGE_ALERT_SHOW", false);
    },
    handleClose() {
      this.$store.commit("CHANGE_PASS_SHOW", false);
    },
  },
  computed: {
    deleteDialogShow () {
      return this.$store.state.deleteDialogShow;
    },
    dialogShow() {
      return this.$store.state.changePassShow;
    },
    alertShow() {
      return this.$store.state.alertShow;
    },
    alertText() {
      return this.$store.state.alertText;
    },
    databaseDialogShow() {
      return this.$store.state.databaseDialogShow;
    },
    databaseLoginShow() {
      return this.$store.state.databaseLoginShow;
    },
    databaseId() {
      let databaseId = window.sessionStorage.getItem('databaseId') ? window.sessionStorage.getItem('databaseId') : -9999;
      return databaseId; 
    }
  }
}
</script>

<style>
@import './assets/styles/public.css';
</style>